import React from 'react';
var AsyncGroupOption = /*#__PURE__*/React.lazy(function () {
  return import( /* webpackChunkName: "@atlaskit-internal_@atlassian/user-picker/group-option" */'./main').then(function (module) {
    return {
      default: module.GroupOption
    };
  });
});
export default AsyncGroupOption;